import { createStep, deleteStep, getAllSteps, updateStep } from "../../api/chatbot";

const chatbot = {
    state: {
        chatbot: {
            steps: [],
        },
    },
    getters: {},
    mutations: {
        FETCH_STEPS: (state, payload) => {
            state.chatbot.steps = payload;
        },
        ADD_STEP: (state, payload) => {
            state.chatbot.steps.push(payload.data);
            state.chatbot.steps = state.chatbot.steps.map((x) => {
                if (x._id === payload.id) return { ...x, nextStepId: payload.data._id };
                return x;
            });
        },
        UPDATE_STEP: (state, payload) => {
            state.chatbot.steps = state.chatbot.steps.map((x) => {
                if (x._id === payload._id) return payload;
                return x;
            });
        },
        DELETE_STEP: (state, payload) => {
            state.chatbot.steps = state.chatbot.steps
                .filter((x) => x._id !== payload)
                .map((x) => {
                    if (x.nextStepId === payload) return { ...x, nextStepId: null };
                    return x;
                });
        },
    },
    actions: {
        async getAllSteps({ commit }) {
            try {
                let { data } = await getAllSteps();
                commit("FETCH_STEPS", data);
            } catch (e) {}
        },
        async addStep({ commit }, payload) {
            try {
                let { data } = await createStep(payload.data, payload.id);
                commit("ADD_STEP", { data, id: payload.id });
                return data;
            } catch (e) {}
        },
        async updateStep({ commit }, payload) {
            try {
                let { data } = await updateStep(payload);
                commit("UPDATE_STEP", data);
                return data;
            } catch (e) {}
        },
        async deleteStep({ commit }, payload) {
            try {
                await deleteStep(payload);
                commit("DELETE_STEP", payload);
            } catch (e) {}
        },
    },
};

export default chatbot;
